import React from 'react';
import { Box, Flex, Text, HStack } from '@chakra-ui/react';
import { KDrawerHeaderProps } from '../KDrawer.types';

// this is a template, based on design system, add different headers to use

export const KDrawerHeader = ({
  title,
  description,
  leftItems,
  rightItems,
  titleProps,
  titleWrapperProps,
}: KDrawerHeaderProps) => {
  return (
    <Box width="100%">
      <Flex justify="space-between" align="center" mb={description ? 2 : 0}>
        <HStack spacing={4} {...titleWrapperProps}>
          {leftItems}
          {typeof title === 'string' ? (
            <Text fontSize="lg" fontWeight="semibold" {...titleProps}>
              {title}
            </Text>
          ) : (
            title
          )}
        </HStack>
        {rightItems && <Box>{rightItems}</Box>}
      </Flex>
      {description && (
        <Text color="gray.600" fontSize="sm">
          {description}
        </Text>
      )}
    </Box>
  );
};
